import { render } from "./TableDialogMapping.vue?vue&type=template&id=73cf9442&scoped=true"
import script from "./TableDialogMapping.vue?vue&type=script&lang=js"
export * from "./TableDialogMapping.vue?vue&type=script&lang=js"

import "./TableDialogMapping.vue?vue&type=style&index=0&id=73cf9442&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cf9442"]])

export default __exports__